import { Directive, HostListener, Input } from '@angular/core';

import { Performance } from '../../../shared/services/performance.service';
import { InstrumentationParam, InstrumentationParams, InstrumentationService, KnownInstrumentationEvents } from '../../instrumentation/instrumentation.service';
import { CapabilitiesService } from '../../shared-context/capabilities.service';

@Directive({
    selector: '[ohpHoverTelemetry]'
})
export class HoverTelemetryDirective {
    @Input('ohpHoverTelemetry') private readonly area: string;

    private readonly enabled: boolean;
    private startTime: number;

    constructor(
        capabilitiesService: CapabilitiesService,
        private readonly instrumentationService: InstrumentationService
    ) {
        this.enabled = capabilitiesService.capabilities.hoverPreloadTelemetryEnabled;
    }

    @HostListener('mouseenter')
    public onMouseEnter() {
        if (this.enabled) {
            this.startTime = Performance.now();
        }
    }

    @HostListener('mouseleave')
    public onMouseLeave() {
        if (this.startTime) {
            this.log(false);
        }
    }

    @HostListener('click')
    public onClick() {
        if (this.startTime) {
            this.log(true);
        }
    }

    private reset() {
        this.startTime = null;
    }

    private log(clicked: boolean) {
        const timeElapsed = this.getTimeElapsed().toString();
        const params: InstrumentationParams = {};
        params[InstrumentationParam.TimeElapsed] = timeElapsed;
        params[InstrumentationParam.Area] = this.area;
        params[InstrumentationParam.DocumentHoverClick] = clicked.toString();

        this.instrumentationService.logGenericEvent(KnownInstrumentationEvents.DocumentHover, params);
        this.reset();
    }

    private getTimeElapsed(): number {
        return Performance.now() - this.startTime;
    }
}
